import * as React from 'react';
import { Button, Col } from 'react-bootstrap';
import { WithTranslation, withTranslation } from 'react-i18next';

import { FormUtil } from '../common/FormUtil';
import moment from 'moment';
import { constants } from '../../constants/constants';
import { toastr } from 'react-redux-toastr';
import {
    FormGroup,
    FormGenerator,
    FieldConfig,
    AbstractControl
} from 'react-reactive-form';
import { WithCommonModal } from '../common/WithCommonModal';

interface Iprops {
    show: boolean;
    onHide: () => void;
    className?: string;
    secondModal?: boolean;
    onPrint: (date: moment.Moment) => void;
}

const PrintUpdatedListModal: React.FC<Iprops & WithTranslation> = props => {
    const { t, show, onHide, onPrint } = props;
    const [selectedDate, setSelectedDate] = React.useState<moment.Moment>(
        moment().subtract(1, 'year')
    );
    const formGroupRef = React.useRef<FormGroup>();

    const fieldConfig: FieldConfig = {
        controls: {
            inspectionDate: {
                render: FormUtil.Datetime,
                meta: {
                    label: t('dashboardAnalytics:includeAssetsInspectedAfter'),
                    colWidth: 12,
                    showTime: false,
                    required: true,
                    name: 'inspection-date',
                    placeholder: t('dashboardAnalytics:selectDate')
                },
                options: {
                    validators: [
                        FormUtil.validators.requiredWithTrim,
                        FormUtil.validators.isValidMoment
                    ]
                },
                formState: {
                    value: selectedDate,
                    disabled: false
                }
            }
        }
    };

    const handlePrint = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!selectedDate) {
            toastr.warning(
                t('common:warning'),
                t('dashboardAnalytics:selectDateWarning'),
                constants.toastrWarning
            );
            return;
        }
        onPrint(selectedDate);
        onHide();
    };

    return (
        <form onSubmit={handlePrint} className="print-updated-list-modal">
            <FormGenerator
                fieldConfig={fieldConfig}
                onMount={(form: AbstractControl) => {
                    if (form instanceof FormGroup) {
                        formGroupRef.current = form;
                        form.get('inspectionDate').valueChanges.subscribe(
                            (value: any) => {
                                setSelectedDate(value);
                            }
                        );
                    }
                }}
            />
            <Col xs={12} className="form-buttons">
                <Button type="button" onClick={onHide}>
                    {t('common:cancel')}
                </Button>
                <Button type="submit" bsStyle="primary">
                    {t('common:emailMe')}
                </Button>
            </Col>
        </form>
    );
};

export default withTranslation()(WithCommonModal(PrintUpdatedListModal));
